export class Dictionary {
  items: { [index: string]: string } = {};
  constructor() {
    this.items = {};
  }

  public initializeItems(newItems: any) {
    this.items = newItems;
  }

  public has(key: string) {
    return key in this.items;
  }

  public set(key: string, value: any) {
    this.items[key] = value;
  }

  public get(key: string) {
    return this.items[key];
  }

  public delete(key: string) {
    if (this.has(key)) {
      delete this.items[key];
      return true;
    }
    return false;
  }
}
